// TODO: should maybe bee an overload of crop()
export function intersectWeatherModelBoundingBox(gridRequest, modelBounds) {
    const intersection = modelBounds.contains(gridRequest.area.project(modelBounds.crs));
    return intersection;
}
export function isWholeAreaOutsideWeatherModelBoundingBox(gridRequest) {
    if (!gridRequest.boundingBoxLimit) {
        return false;
    }
    return intersectWeatherModelBoundingBox(gridRequest, gridRequest.boundingBoxLimit).kind === "OutOfBounds";
}
//# sourceMappingURL=intersectWeatherModelBoundingBox.js.map